import React from 'react';
import { generateGoogleMapsUrl } from '../../utils/location-util';
import { Address } from '../../mock-data/address/addresses-data';

interface LocationLinkProps {
  // New approach: use Address object
  address?: Address;
  // Legacy approach: maintain backward compatibility
  location?: string;
  locationUrl?: string;
  className?: string;
  children?: React.ReactNode;
}

/**
 * LocationLink component that opens location links in a new tab when clicked
 * @param address - Address object with name and url (preferred approach)
 * @param location - Legacy: location text (fallback)
 * @param locationUrl - Legacy: custom URL (fallback)
 * @param className - Optional CSS classes to apply
 * @param children - Optional children to render instead of the address name
 */
const LocationLink: React.FC<LocationLinkProps> = ({
  address,
  location,
  locationUrl,
  className = "",
  children
}) => {
  // Determine final values based on priority: address object > legacy fields
  const finalName = address?.name || location || '';
  const finalUrl = address?.url || locationUrl || generateGoogleMapsUrl(finalName);

  const handleLocationClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open(finalUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <a
      href={finalUrl}
      onClick={handleLocationClick}
      className={`text-current hover:opacity-75 no-underline cursor-pointer transition-opacity duration-200 ${className}`}
      target="_blank"
      rel="noopener noreferrer"
      title={`Open ${finalName} in Maps`}
    >
      {children || finalName}
    </a>
  );
};

export default LocationLink;

